import {inject} from "@angular/core";
import {NavigationService} from "../../core/services/navigation.service";
import {PermissionsService} from "../../core/services/permissions.service";
import {UserService} from "../../core/services/user.service";
import {forkJoin, take} from "rxjs";

export const platformDataResolver = () => {
    const navigationService = inject(NavigationService);
    const permissionService = inject(PermissionsService);
    const userService = inject(UserService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        forkJoin([
            permissionService.getAllGroups(),
            permissionService.initFeaturesFromToken()
        ]).pipe(take(1)),
        navigationService.get(),
    ]).subscribe({
        next: (rez) => {},
        complete: () => {
            //initialize user service
            userService.initLoggedInUser();
            userService.getTeam(true);
        },
        error: err => { console.error("Error in app resolver: ", err)}
    });
};
